import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María García', 'Juan Pérez', 'Carlos Rodríguez', 'Laura Martínez', 'Ana López', 'Pedro González', 'Sofía Hernández', 'Diego Díaz', 'Valentina Torres', 'Miguel Ángel', 'Camila Flores', 'Javier Ruiz'];
const COUNTRIES = ['Argentina', 'México', 'Colombia', 'España', 'Chile', 'Perú', 'Estados Unidos', 'Uruguay', 'Ecuador'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    country: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setData({
        name: randomName,
        country: randomCountry
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 8 and 15 seconds + 4 seconds display time
      const randomDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showPopup, randomDelay);
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-217">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center gap-3" data-id="element-218">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-219">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-220" />
          </div>
          <div data-id="element-221">
            <p className="text-sm font-bold text-gray-900" data-id="element-222">{data.name}</p>
            <p className="text-xs text-gray-600" data-id="element-223">
              de {data.country} compró el Mega Pack
            </p>
            <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-224">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}